
















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import PicModal from '@/components/upload/picModal.vue'
import SelectUrl from '../floorSet/components/selectUrl.vue'
import HeaderApi from '@/api/shopMall/pcMallDecorate/headerSet/index'
@Component({
  components: {
    PicModal,
    SelectUrl,
  },
})
export default class Swiper extends Vue {
  // @Prop({
  //   type: Object,
  //   default: () => {
  //     return {
  //       interval: 3000,
  //       imgUrl: [],
  //     }
  //   },
  // })
  // SwiperConfig!: any
  defaultImg: string = 'https://evestemptation.obs.cn-east-3.myhuaweicloud.com/image/1591931215346EBElogo.jpg'
  defaultUrl: string = ''

  mounted() {
    HeaderApi.getConfig('NavigationBarConfig')
      .then((res) => {
        console.log(res)
        this.defaultImg = res.data.picUrl
        this.defaultUrl = res.data.jumpLink
      })
      .catch((err) => {
        console.log(err)
      })
  }

  /**
   * 选择图片
   */
  picChange(e) {
    this.defaultImg = e[0].url
  }

  /**
   * 选择链接
   */
  urlChange(e) {
    this.defaultUrl = e
  }

  /**
   * 删除图片
   */
  // deleteFn(index) {
  //   this.SwiperConfig.imgUrl.splice(index, 1)
  // }

  /**
   * 添加图片
   */
  // addFn() {
  //   let obj = {
  //     img: null,
  //     url: null,
  //   }
  //   this.SwiperConfig.imgUrl.push(obj)
  // }
  /**
   * 提交
   */
  handleSubmit() {
    HeaderApi.updateConfig('NavigationBarConfig', '导航设置', {
      picUrl: this.defaultImg,
      jumpLink: this.defaultUrl,
    })
      .then((res) => {
        console.log(res)
        this.$Notice.success({
          desc: '修改成功',
        })
        this.$router.push({
          name: 'pcMallDecorate',
        })
      })
      .catch((err) => {
        console.log(err)
        this.$Notice.warning({
          title: '修改失败',
        })
      })
  }
}
